import { allThemes } from "@arbeidsark/shared"
import type { WorksheetTheme } from "@arbeidsark/shared"
import { Select, type SelectOption, type SelectProps } from "~/components"
import { useTranslate } from "~/ur-react-hooks"

export interface ThemeSelectProps
  extends Omit<SelectProps<WorksheetTheme>, "options"> {}

const ThemeSelect: React.FC<ThemeSelectProps> = ({ ...props }) => {
  const translations = useTranslate({
    "17mai": "worksheets.themes.17mai",
    christmas: "worksheets.themes.christmas",
    halloween: "worksheets.themes.halloween",
    mermaids: "worksheets.themes.mermaids",
    numberchars: "worksheets.themes.numberchars",
    space: "worksheets.themes.space",
    tools: "worksheets.themes.tools",
    unicorn: "worksheets.themes.unicorn",
  })

  const options: SelectOption<WorksheetTheme>[] = allThemes.map((theme) => ({
    value: theme,
    label: translations[theme],
  }))

  return <Select {...props} options={options} />
}

export default ThemeSelect
